/**
 * @file STRV logo. Source SVG is in public/strv-logo.svg (copied verbatim from
 * strvcom/strv-device-sale, which sourced it from brand.strv.com). Inlined
 * here so each render gets a fresh DOM node — SVG elements can't be
 * appended to multiple parents.
 *
 * Fill is hardcoded to STRV red (#EF0D33). The .logo svg CSS rules don't
 * need to set a fill.
 */

import { svgFromMarkup } from './lib/svg.js';

const STRV_SVG = `
<svg viewBox="0 0 1280 574" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="STRV">
  <path d="M1280 6.01752H1190.08L1125.05 422.693L1060.02 6.01752H965.286L1071.26 568.007H1174.02L1280 6.01752Z" fill="#EF0D33"/>
  <path d="M950.339 568.007L870.055 329.563C908.591 312.703 931.071 278.984 931.071 225.193V124.838C931.071 39.7369 874.872 6.01752 789.77 6.01752H644.456V568.007H737.586V344.014H784.15L855.603 568.007H950.339ZM737.586 87.9074H786.559C817.067 87.9074 837.941 99.1472 837.941 139.289V212.348C837.941 252.49 817.067 263.73 786.559 263.73H737.586V87.9074Z" fill="#EF0D33"/>
  <path d="M278.783 206.728V115.204C278.783 31.7084 217.767 -0.405273 140.695 -0.405273H139.089C62.0161 -0.405273 1.00006 31.7084 1.00006 115.204V189.065C1.00006 247.673 32.3109 273.364 86.9042 304.675L151.934 341.605C180.034 356.859 188.865 371.311 188.865 400.213V444.369C188.865 478.892 168.794 494.146 140.695 494.146C112.595 494.146 92.5241 478.892 92.5241 444.369V359.268H1.00006V457.215C1.00006 544.725 54.7905 574.43 139.892 574.43H141.497C226.599 574.43 280.389 543.922 280.389 457.215V376.128C280.389 315.915 248.275 291.026 194.485 260.518L128.652 223.588C102.158 208.334 92.5241 195.488 92.5241 166.586V128.049C92.5241 92.7244 112.595 79.8789 139.892 79.8789C167.188 79.8789 187.259 92.7244 187.259 128.049V206.728H278.783Z" fill="#EF0D33"/>
  <path d="M596.684 6.01752H315.689V87.9074H409.622V568.007H502.751V87.9074H596.684V6.01752Z" fill="#EF0D33"/>
</svg>
`.trim();

/** Returns a fresh SVGElement for embedding. */
export function strvLogo() {
  return svgFromMarkup(STRV_SVG);
}
